



























































import { Vue, Component } from "vue-property-decorator";
import { LetterTemplateModel } from "@/api/LetterTemplates/models";
import { listLetterTemplates } from "@/api/LetterTemplates/listLetterTemplates";
import { uploadLetterTemplate, UploadLetterTemplatesRequest } from "@/api/LetterTemplates/uploadLetterTemplate";
import { deleteLetterTemplate } from "@/api/LetterTemplates/deleteLetterTemplate";
import { downloadLetterTemplate } from "@/api/LetterTemplates/downloadLetterTemplate";
import { reaction } from "mobx";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { LoadingStore } from "@/store/loadingStore";
import { Observer } from "mobx-vue";
import userStore from "@/store/userStore";
import notificationStore from "@/store/notificationStore";

@Observer
@Component({
  components: {
    ValidationProvider,
    ValidationObserver
  }
})
export default class LetterTemplateList extends Vue {
  $refs!: {
    form: HTMLElement & { reset: () => void };
  };
  loading = new LoadingStore();
  letterTemplates: LetterTemplateModel[] = [];
  headers = [
    { text: "File Name", value: "fileName" },
    { text: "", value: "actions", width: "1%", sortable: false }
  ];
  isUploadTemplateDialogOpen = false;
  dispose?: () => void;
  uploadTemplateForm = {};
  isUploadingTemplate = false;

  mounted() {
    this.fetchData();

    this.dispose = reaction(() => [userStore.activeCouncil], this.fetchData);
  }

  private async fetchData() {
    this.loading.track(async () => {
      try {
        if (userStore.activeCouncil) {
          this.letterTemplates = [];
          this.letterTemplates = await listLetterTemplates();
        }
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading the letter templates");
      }
    });
  }

  async downloadTemplate(letterTemplate: LetterTemplateModel) {
    this.loading.track(async () => {
      try {
        if (userStore.activeCouncil) {
          await downloadLetterTemplate({
            letterTemplateId: letterTemplate.id,
            filename: letterTemplate.fileName
          });
        }
      } catch (error) {
        notificationStore.error("An unexpected error occurred while dowloading the template");
      }
    }, "download");
  }

  async uploadTemplate() {
    try {
      this.isUploadingTemplate = true;
      const letterTemplate = await uploadLetterTemplate({ ...this.uploadTemplateForm } as UploadLetterTemplatesRequest);
      this.letterTemplates.push(letterTemplate);
      this.closeUploadTemplateDialog();
    } catch (error) {
      notificationStore.error("An unexpected error occurred while dowloading the template");
    } finally {
      this.isUploadingTemplate = false;
    }
  }

  closeUploadTemplateDialog() {
    this.$refs.form.reset();
    this.isUploadTemplateDialogOpen = false;
    this.uploadTemplateForm = {};
  }

  async deleteTemplate(letterTemplate: LetterTemplateModel) {
    this.loading.track(async () => {
      try {
        if (userStore.activeCouncil && confirm("Are you sure you want to delete the template?")) {
          await deleteLetterTemplate({ letterTemplateId: letterTemplate.id });

          const index = this.letterTemplates.indexOf(letterTemplate);
          this.letterTemplates.splice(index, 1);
        }
      } catch (error) {
        notificationStore.error("An unexpected error occurred while deleting the template");
      }
    }, "delete");
  }

  async destroyed() {
    if (this.dispose) this.dispose();
  }
}
